import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'
import { useEffect } from 'react'
import Landing from './pages/Landing'
import Dashboard from './pages/Dashboard'
import ProjectView from './pages/ProjectView'
import ProjectViewer from './pages/ProjectViewer'
import LoadingScreen from './components/ui/LoadingScreen'

function App() {
  const { user, loading, checkAuth } = useAuthStore()

  useEffect(() => {
    const unsubscribe = checkAuth()
    return () => {
      if (unsubscribe) unsubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // Only run once on mount

  if (loading) {
    return <LoadingScreen />
  }

  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <div className="min-h-screen">
        <Routes>
          <Route 
            path="/" 
            element={user ? <Navigate to="/dashboard" replace /> : <Landing />} 
          />
          <Route 
            path="/dashboard" 
            element={user ? <Dashboard /> : <Navigate to="/" replace />} 
          />
          <Route 
            path="/project/:id" 
            element={user ? <ProjectView /> : <Navigate to="/" replace />} 
          />
          <Route 
            path="/view/:id" 
            element={<ProjectViewer />} 
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App 